import React from 'react';

import autoBind from 'react-autobind';
import classNames from "classnames";

// import other components within the same project here

import { Snackbar, SnackbarContent, withStyles } from '@material-ui/core';

import {
  green,
  pink,
  amber,
} from '@material-ui/core/colors';

const styles = {
  succeess: {
    backgroundColor: green[600]
  },
  error: {
    backgroundColor: pink["A400"]
  },
  warning: {
    backgroundColor: amber[700]
  },
};

function MySnackbarContent(props) {
  const { classes, className, message, variant } = props;
  return (
    <SnackbarContent
      className={classNames(classes[variant], className)}
      message={message}
    />
  );
}

const MySnackbarContentWrapper = withStyles(styles)(MySnackbarContent);

class Notification extends React.Component {
  queue = [];

  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      open: false,
      messageInfo: {},
    };
    autoBind(this);
  }

  processQueue() {
    if (this.queue.length > 0) {
      this.setState({
        messageInfo: this.queue.shift(),
        open: true,
      })
    }
  }

  handleClose() {
    this.setState({ open: false });
    this.state.open = false;
  }

  handleExited() {
    //this.processQueue();
  }

  add(message) {
    /*this.queue.push({
      message,
    });

    /*if (this.state.open) {
      this.setState({ open: false });
    } else {
      this.processQueue();
    }*/
    this.setState({
      messageInfo: { message },
      open: true,
    })
  }

  render() {
    return (
      <div>
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          open={this.state.open}
          autoHideDuration={6000}
          disableWindowBlurListener={true}
          onClose={this.handleClose}
          onExited={this.handleExited}
        >
          <MySnackbarContentWrapper
            variant="error"
            message={this.state.messageInfo.message}
          />
        </Snackbar>
      </div>
    )
  }
}

export default Notification;
